import React, { useState, useEffect } from 'react';
import { X, Gift } from 'lucide-react';
import { promoCode } from '../data/mock';

const PromoPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    // Check if popup was already shown
    const popupShown = localStorage.getItem('promo_popup_shown');
    
    if (!popupShown) {
      // Show popup after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosed(true);
    setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem('promo_popup_shown', 'true');
    }, 300);
  };

  const copyCode = () => {
    navigator.clipboard.writeText(promoCode.code);
    alert('Kod je kopiran!');
  };

  if (!isVisible) return null;

  return (
    <div className={`promo-popup-overlay ${isClosed ? 'closing' : ''}`}>
      <div className={`promo-popup ${isClosed ? 'closing' : ''}`}>
        <button className="promo-popup-close" onClick={handleClose}>
          <X size={24} />
        </button>
        
        <div className="promo-popup-content">
          <div className="promo-popup-icon">
            <Gift size={48} />
          </div>
          
          <h3 className="promo-popup-title">Dobrodošli!</h3>
          <p className="promo-popup-text">
            Kao znak dobrodošlice, poklanjamo vam <strong>{promoCode.discount}% popusta</strong> na prvu porudžbinu!
          </p>
          
          <div className="promo-popup-code" onClick={copyCode}>
            <span className="code-label">Vaš kod:</span>
            <span className="code-value">{promoCode.code}</span>
            <span className="code-copy">Klikni da kopiraš</span>
          </div>
          
          <button className="promo-popup-button" onClick={handleClose}>
            Započni kupovinu
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoPopup;
